/**
 * @description: 加载js
 * @param {*} jsInfo
 * @param {*} callback
 * @param {*} errcallback
 * @return {*}
 */
interface IJsInfo {
  src: string;
  isAsync?: boolean;
  isDefer?: boolean;
  customAttr?: {
    [key: string]: string;
  };
}
export function loadJS(jsInfo: IJsInfo, callback, errcallback) {
  const documentHeader = document.head || document.getElementsByTagName('head')[0];
  const scripts = document.getElementsByTagName('script');
  // 防止单页应用加载多次
  let addSign = true;
  const {
    src = '', isAsync = false, isDefer = false, customAttr = {}
  } = jsInfo || {};
  if (!src) {
    console.error('src参数不存在');
    return;
  }
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i] && scripts[i].src && scripts[i].src.indexOf(src) !== -1) {
      addSign = false;
    }
  }
  // 已添加过
  if (!addSign) {
    callback && callback();
    return;
  }
  // 未添加过
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.charset = 'utf-8';
  if (isAsync) {
    script.async = true;
  }
  if (isDefer) {
    script.defer = true;
  }
  if (customAttr) {
    Object.keys(customAttr).forEach((item) => {
      script.setAttribute(item, customAttr[item]);
    });
  }
  script.src = src;
  documentHeader.appendChild(script);
  // eslint-disable-next-line
    script.onload = script["onreadystatechange"] = function () {
    callback && callback();
  };
  script.onerror = function () {
    errcallback && errcallback();
    documentHeader.removeChild(script);
  };
}
